module.exports = __webpack_public_path__ + "static/media/sel_10_247.feb5eab0.mp4";